"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SortByType;
(function (SortByType) {
    SortByType["LAST_EDITED"] = "LAST_EDITED";
    SortByType["LAST_OPENED"] = "LAST_OPENED";
    SortByType["CREATION_DATE"] = "CREATION_DATE";
    SortByType["ALPHABETICAL"] = "ALPHABETICAL";
    SortByType["ID_NUMBER"] = "ID_NUMBER";
    SortByType["ORDER_NUMBER"] = "ORDER_NUMBER";
})(SortByType = exports.SortByType || (exports.SortByType = {}));
//# sourceMappingURL=SortByType.js.map